import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import "react-circular-progressbar/dist/styles.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { toast } from "react-toastify";
import Axios from "../axios";
import HotelIcon from "@mui/icons-material/Hotel";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Helmet } from "react-helmet";

import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const [data, setData] = useState();
  useEffect(() => {
    fetchAllData();
  }, []);

  const bookingGraphData = {
    labels: data?.month || [],
    datasets: [
      {
        label: "Total Bookings",
        data: data?.bookingListMonthlyCountData || [],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        yAxisID: "y",
      },
    ],
  };
  const userGraphData = {
    labels: data?.month || [],
    datasets: [
      {
        label: "Total Users",
        data: data?.userListMonthlyCountData || [],
        borderColor: "rgba(153, 102, 255, 1)",
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        yAxisID: "y",
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: "Months",
        },
        grid: {
          display: false,
        },
      },
      y: {
        type: "linear",
        display: true,
        position: "left",
        title: {
          display: true,
        },
        grid: {
          display: false,
        },
      },
    },
  };

  const fetchAllData = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "dashboard-data")
      .then((resp) => {
        setData(resp?.data?.data);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  return (
    <>
      <Helmet>
        <title>Sevenly-Dashboard</title>
        <meta name="FAQ" content="FAQ for Home Page" />
      </Helmet>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <h2 className="mb-4">Dashboard </h2>
      <div className="row p-3">
        <div className="col-md-2">
          <div className="flex w100">
            <div>
              <Card className="border_radius ">
                <CardContent>
                  <div className="d-flex justify-content-between">
                    <div className="text-left">
                      <h5 style={{ fontSize: "15px" }}>Total Bookings</h5>
                      <h2 className="success" style={{ fontSize: "40px" }}>
                        {data?.totalConfirmedBookings}
                      </h2>
                    </div>
                    <div>
                      <HotelIcon
                        style={{ fontSize: "80px", color: "#3dd2cc" }}
                      />
                    </div>
                  </div>
                  <p className="m-1 fs-12 fw-600" style={{ color: "grey" }}>
                    Confimed Bookings
                  </p>
                </CardContent>
              </Card>
            </div>
            <div className="mt-5">
              {/* <Card className="border_radius px-4">
                <CardContent>
                  <div className="d-flex justify-content-between">
                    <div className="text-left">
                      <h5>Total Revenue</h5>
                      <h2 className="success" style={{ fontSize: "40px" }}>
                        {data?.totalRate}
                      </h2>
                    </div>
                    <div>
                      <PaidIcon style={{ fontSize: "80px" }} />
                    </div>
                  </div>
                </CardContent>
              </Card> */}
            </div>
            <div className="mt-5">
              <Card className="border_radius ">
                <CardContent>
                  <div className="d-flex justify-content-between">
                    <div className="text-left">
                      <h5 style={{ fontSize: "15px" }}>Total Users</h5>
                      <h2 className="success" style={{ fontSize: "40px" }}>
                        {data?.totalUsers}
                      </h2>
                    </div>

                    <div>
                      <AccountCircleIcon
                        style={{ fontSize: "80px", color: "#9966ff" }}
                      />
                    </div>
                  </div>
                  <p className="m-1 fs-12 fw-600" style={{ color: "grey" }}>
                    Yearly Users
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
        <div className="col-md-5 ">
          <Card className="border_radius">
            <CardContent>
              <p className="fw-700 fs-16">Total Bookings Analytics </p>
              <Line data={bookingGraphData} options={options} />
            </CardContent>
          </Card>

          <div
            className=" graphImage"
            style={{
              marginTop: "200px",
              alignContent: "center",
              justifyContent: "center",
              fontSize: "30px",
              marginLeft: "300px",
            }}
          ></div>
        </div>
        <div className="col-md-5">
          <Card className="border_radius">
            <CardContent>
              <p className="fw-700 fs-16">Total User Analytics </p>

              <Line data={userGraphData} options={options} />
            </CardContent>
          </Card>

          <div
            className=" graphImage"
            style={{
              marginTop: "200px",
              alignContent: "center",
              justifyContent: "center",
              fontSize: "30px",
              marginLeft: "300px",
            }}
          ></div>
        </div>
      </div>
    </>
  );
};
export default Dashboard;
